<template>
<div>
  <div>Code: <input type='text' v-model='code' style='width: 200px' /></div>
  <canvas ref='canvas' @mousedown="start_moving($event)" @mouseup='dragging=false' @mouseleave='dragging=false' @mousemove='move($event)' />
  <img ref='img' :src="photo.url_orig" style='display: none' @load='init'/>
  <img ref='overlay' src="https://brookseeevents.s3.amazonaws.com/rev/2020/albums/revoverlay_web.png" @load='init' style='display:none' />
</div>
</template>


<script>

export default {
    props: {
	photo: Object,
	initcode: String,
    },
    data: function() { return {
	off_x: 0,
	off_y: 0,
	dragging: false,
	prev_x: null,
	prev_y: null,
	ctx: null,
	portrait: null,
	code: "Rocks",
    }},
    methods: {
	start_moving: function(evt) {
	    this.dragging = true
	    this.prev_x = evt.clientX
	    this.prev_y = evt.clientY
	},
	move: function(evt) {
	    if(this.dragging) {
		if(this.portrait) {
		    this.off_y = this.off_y + evt.clientY - this.prev_y
		    this.prev_y = evt.clientY
		    if(this.off_y > 0)
			this.off_y = 0;
		} else {
		    this.off_x = this.off_x + evt.clientX - this.prev_x
		    this.prev_x = evt.clientX
		    if(this.off_x > 0)
			this.off_x = 0;
		}
		this.draw()
	    }
	},
	init: function() {
	    var c = this.$refs.canvas
	    this.ctx = c.getContext("2d");
	    var overlay = this.$refs.overlay
	    c.width = overlay.naturalWidth
	    c.height = overlay.naturalHeight
	    var img = this.$refs.img
	    this.portrait = img.naturalWidth < img.naturalHeight
	    this.off_y = 0
	    this.off_x = 0
	    this.draw()
	},
	draw: function() {
	    var c = this.$refs.canvas
	    var img = this.$refs.img
	    var overlay = this.$refs.overlay
	    this.ctx.clearRect(0, 0, c.width, c.height)
	    var iw, ih;
	    if(this.portrait) {
		iw = c.width
		ih = iw / img.naturalWidth * img.naturalHeight
	    } else {
		ih = c.height
		iw = ih * img.naturalWidth / img.naturalHeight
	    }
	    this.ctx.drawImage(img, this.off_x, this.off_y, iw, ih)
	    this.ctx.drawImage(overlay, 0, 0, overlay.naturalWidth, overlay.naturalHeight)
	    this.ctx.fillStyle = 'white'
	    this.ctx.textAlign = 'center'
	    this.ctx.font = 'bold 40px Futura, Arial, Helvetica, sans-serif'
	    this.ctx.fillText("USE MY CODE: " + this.code, c.width/2, 690)
	    this.ctx.font = '20px Futura, Arial, Helvetica, sans-serif'
	    this.ctx.fillText("SIGN UP FOR ANY REVEL RACE AND RECEIVE", c.width/2, 720)
	    this.ctx.font = 'bold 50px Futura, Arial, Helvetica, sans-serif'
	    this.ctx.fillText("13.1% OFF", c.width/2, 770)
	},
    },
    mounted: function() {
	if(this.initcode !== null && this.initcode !== undefined) {
	    this.code = this.initcode
	}
    },
  }
  
</script>


<style scoped>

canvas {
}
</style>
